import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { TextAsset } from 'src/app/models/assets/TextAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { FontService } from 'src/app/services/font.service';
import { TextToSpeechService } from 'src/app/services/text-to-speech.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-text-details',
  templateUrl: './text-details.component.html',
  styleUrls: ['./text-details.component.scss'],
})
export class TextDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public fontFamily: any[];
  public ionSelectFontOptions = {
    cssClass: 'select-font quizard-select'
  };
  public selectOptions = {
    cssClass: 'quizard-select'
  };

  constructor( 
    public assetTypeService: AssetTypeService,
    public fontService: FontService,
    public textToSpeechService: TextToSpeechService,
    public validationService: ValidationService,
   ) {  
    this.fontFamily = this.fontService.fontFamilyOptions;
   }

  ngOnInit() { 
   }

  getTextAsset(): TextAsset {
    return this.assetInScene.baseAsset as TextAsset;
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  validateText(textAsset: TextAsset){
    textAsset.text = textAsset.text ? textAsset.text : "";
    textAsset.text = this.validationService.removeExcessLineBreaks(textAsset.text);
  }

  textToSpeechChange(event, assetInScene: AssetInScene) {
    if (!event.target.checked) {
      assetInScene.sceneAssetRelation.textToSpeechUrl = null;
    }else
    this.textToSpeechService.setTextAssetTextToSpeech(assetInScene);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var sceneSettingsModal = document.getElementById('add-text-object-modal');
    sceneSettingsModal.style.opacity = opacity;
  }

  updateXScale(event, asset) {
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    asset.sceneAssetRelation.yScale = String(event.detail.value);
    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  backgroundVisibleChange(event, assetInScene: AssetInScene) {
    let textAsset = assetInScene.baseAsset as TextAsset;
    textAsset.hasBackground= textAsset.hasBackground;
    if (event.target.checked) {
      textAsset.hasBackground = true;
    } else {
      textAsset.hasBackground = false;
    }
  }
  validateTextBackgroundColour(event, assetInScene: AssetInScene) {
    var textAsset = this.getTextAsset();
    if (textAsset.backgroundColour.trim().length == 0) {
      textAsset.backgroundColour = "#FFFFFF";
    }
  }
}
